import { Component } from '@angular/core';

@Component({
    selector: 'gea-svg-success',
    templateUrl: './success.component.html',
    standalone: false
})
export class SuccessComponent {

}
